import React from "react";
import styled from "styled-components/macro";
import { DismissRegular, FilterRegular } from "@fluentui/react-icons";

import { MONTH_STATUS, MONTH_STATUS_DETAILS } from "./constants";
import { UnstyledButton } from "./index.style";

const TODOS = [
    {
        status: MONTH_STATUS.not_declared,
        key: "not_declared_months",
        label: "mois à déclarer",
        activeBg: "#FEF6E6",
    },
    {
        status: MONTH_STATUS.not_validated,
        key: "not_validated_months",
        label: "mois à valider",
        activeBg: "#EEF0FE",
    },
];

/**
 * Boutons "x mois à déclarer / à valider", ils filtrent le tableau sur un seul statut
 * @param {{ todo: object, selectedStatus: string[], onPick: function }} props
 */
const TodoButtons = ({ todo, selectedStatus = [], onPick }) => (
    <Wrapper>
        {TODOS.map((item) => {
            const isActive =
                selectedStatus.length === 1 &&
                selectedStatus[0] === item.status;
            return (
                <TodoButton
                    key={item.status}
                    title={`Filtrer le tableau sur l'état ${
                        MONTH_STATUS_DETAILS[item.status].label
                    }`}
                    $border={MONTH_STATUS_DETAILS[item.status].color}
                    $bg={isActive ? item.activeBg : "#fff"}
                    $hoverBg={item.activeBg}
                    onClick={() => onPick(item.status)}
                >
                    <Count>{todo?.[item.key] ?? 0}</Count>
                    {item.label}
                    {isActive ? (
                        <DismissRegular fontSize={12} color="#212121" />
                    ) : (
                        <FilterRegular fontSize={12} color="#616161" />
                    )}
                </TodoButton>
            );
        })}
    </Wrapper>
);

export default TodoButtons;

const Wrapper = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

const TodoButton = styled(UnstyledButton)`
    display: flex;
    align-items: center;
    gap: 8px;
    background: ${({ $bg }) => $bg};
    border: 1px solid ${({ $border }) => $border};
    border-radius: 4px;
    padding: 5px 12px;
    font-size: 13px;
    color: #212121;
    &:hover {
        background: ${({ $hoverBg }) => $hoverBg};
    }
`;

const Count = styled.span`
    font-weight: 700;
    font-size: 15px;
`;
